import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const StudentLearningAnalytics = () => {
    return (
        <div>
            <h5 className="mb-4 text-dark font-weight-bold">Learning Analytics</h5>
            <Row>
                <Col md={6}>
                    <Card className="border-0 shadow-sm p-4 mb-4" style={{ borderRadius: '12px', background: '#f8fafc' }}>
                        <h6 className="font-weight-bold text-primary mb-3">Key Strengths</h6>
                        <ul className="pl-3 text-secondary">
                            <li className="mb-2"><strong>Logical Reasoning:</strong> Outstanding performance in geometry & algebraic derivations.</li>
                            <li className="mb-2"><strong>Algorithm Understanding:</strong> Scored 100% conceptual clarity in loops and conditional statements in computer science.</li>
                            <li className="mb-2"><strong>Vocabulary:</strong> Strong retention and comprehension skills in language arts.</li>
                        </ul>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="border-0 shadow-sm p-4 mb-4" style={{ borderRadius: '12px', background: '#f8fafc' }}>
                        <h6 className="font-weight-bold text-danger mb-3">Areas for Improvement</h6>
                        <ul className="pl-3 text-secondary">
                            <li className="mb-2"><strong>Time Management:</strong> Tends to leave complex math problems for the end, leading to rushed answers.</li>
                            <li className="mb-2"><strong>Experimental Physics:</strong> Requires more practical sessions to grasp measurement instruments.</li>
                            <li className="mb-2"><strong>Grammar Details:</strong> Minor punctuation errors in creative writing assignments.</li>
                        </ul>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default StudentLearningAnalytics;
